import getMlsThreshold from '../get-mls-threshold';

const calculateMls = ({ income, thresholds }: { income: number; thresholds: any }) => {
  const matchedThreshold = getMlsThreshold({ income, thresholds });
  const rate = matchedThreshold?.rate ?? 0;

  return (income * rate) / 100;
};

export default calculateMls;
